import { savedOrderDetailsHeaderStyles as styles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.titleGridItem = {
    ...styles.titleGridItem,
    css: css`
        padding-bottom: 40px;
        ${mediaQueriesBP.maxMD} {
            padding-bottom: 24px;
        }
    `,
};

styles.actionButtons = {
    ...styles.actionButtons,
    narrowOverflowMenu: {
        ...styles.actionButtons?.narrowOverflowMenu,
        cssOverrides: {
            ...styles.actionButtons?.narrowOverflowMenu?.cssOverrides,
            menuItem: css`
                color: ${getColor(colorStrings.primaryMain)};
            `,
        },
    },

    middleOverflowMenu: {
        ...styles.actionButtons?.middleOverflowMenu,
        cssOverrides: {
            ...styles.actionButtons?.middleOverflowMenu?.cssOverrides,
            menuItem: css`
                color: ${getColor(colorStrings.primaryMain)};
            `,
        },
    },
};
